module.exports = __webpack_public_path__ + "static/media/cwb-check-circle-solid.3c147c75.svg";